module.exports = __webpack_public_path__ + "static/media/contract_template_p1.06d22c1e.jpg";